import TimeCounter from "@/components/AgentActions/TimeCounter";
import { hDeepCopy } from "@/utils/helpers";

// @vue/component
export default {
  name: "PopoverForAgentList",
  components: {
    TimeCounter
  },
  props: {
    userUuid: {
      type: String,
      required: true
    },
    agentList: {
      type: Array,
      default: () => []
    },
    turnedOff: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isTimerFinished: false,
      breakTime: 0,
      options: []
    };
  },

  computed: {
    isAnyAgentListElement() {
      return !(this.agentList.length === null || this.agentList.length === 0);
    },
    holidayList() {
      // if the holiday is per agent, then it applies only to that agent, if per project, then to all agents of that project
      /* eslint-disable no-nested-ternary */
      let currentHolidays = hDeepCopy(
        this.$store.getters["client/project/holidays/currentList"].records
      ).map(holiday =>
        holiday.element === "agent" && this.agentList.some(agent => agent.id === holiday.element_id)
          ? { ...holiday, isCurrent: true }
          : holiday.element === "project"
          ? { ...holiday, isCurrent: true }
          : { ...holiday, isCurrent: false }
      );
      return currentHolidays.filter(holiday => holiday.isCurrent);
    }
  },
  created() {
    this.prepareBreakOptions();
  },

  methods: {
    isCurrentHoliday(agent) {
      const currentHoliday = this.holidayList.filter(
        holiday =>
          (holiday.element === "agent" && holiday.element_id === agent.id) ||
          (holiday.element === "project" && holiday.element_id === agent.project_id)
      );

      return currentHoliday.length !== 0;
    },
    prepareBreakOptions() {
      for (let i = 5; i < 65; i += 5) {
        this.options.push({
          value: `${i}`,
          label: `${i} minut`
        });
      }
    },
    async toggleAgentStatus(agentUuid, status, actionId, breakTime) {
      if (Number(actionId) === Number(3) && status) {
        this.$refs.timeCounter.stopCounting();
        this.breakTime = 0;
      }
      let params = {
        agent: agentUuid,
        status: !status ? 1 : 0,
        action_id: actionId
      };
      if (breakTime !== 0) {
        params.interval = breakTime;
      }
      await this.$store.dispatch("user/agent/setStatus", params);
      this.getAgentList();
    },
    getAgentList() {
      this.$store.dispatch("user/agent/getAgentsBelongsToUserList", this.userUuid);
    },

    async unlockAgent(agent_uuid) {
      const params = {
        agent_uuid
      };
      await this.$store.dispatch("user/agent/unlockAgent", params);
    },

    openConfirmationModal(agent_uuid) {
      this.$msgbox({
        title: "Czy jesteś pewny że chcesz odblokować agenta?",
        message:
          "Ta funkcja służy do awaryjnego odblokowania kierowania do agenta. Wykorzystaj ją w sytuacji, gdy w Twojej ocenie połączenie się zawiesiło i nie kieruje do Ciebie połączeń.",
        showCancelButton: true,
        customClass: "PopoverForAgentList__confirm-modal",
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "Loading...";
            await this.unlockAgent(agent_uuid);
            instance.confirmButtonLoading = false;
            done();
          } else {
            done();
          }
        }
      }).then(() => {
        this.$message({
          type: "success",
          message: "Agent został odblokowany"
        });
      });
    }
  }
};
